import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import HotWorks from './components/HotWorks';
import StyleCards from './components/StyleCards';
import Artists from './components/Artists';
import Subscribe from './components/Subscribe';
import About from './components/About';
import Faq from './components/Faq';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <div className="relative min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Gallery />
        <HotWorks />
        <StyleCards />
        <Artists />
        <Subscribe />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}